/* eslint-disable */
// @ts-nocheck
/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Brightpick Operations Hub
 * Documentation for Brightpick Operations Hub
 * OpenAPI spec version: 3.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult
} from '@tanstack/react-query';

import { platformAxios } from '../DataLoader';
export interface ConfirmReceiptDto {
    /**
     * Document number
     * @minimum -9007199254740991
     * @maximum 9007199254740991
     */
    docNum: number;
    /** Signature for verification */
    signature: string;
    /**
     * Optional comments
     * @maxLength 200
     */
    comments?: string;
}

/**
 * Current tracking status
 */
export enum TrackingStatus {
    Opened = 'Opened',
    Picked_up = 'Picked up',
    In_transit = 'In transit',
    Out_for_delivery = 'Out for delivery',
    Delivered = 'Delivered',
    Exception = 'Exception',
    Cancelled = 'Cancelled'
}
/**
 * Shipment method
 */
export enum ShipmentMethod {
    Air = 'Air',
    Sea = 'Sea',
    Truck = 'Truck',
    Train = 'Train'
}
/**
 * Current tracking status
 * @nullable
 */
export type TrackingResultDtoStatus = TrackingStatus | null;

/**
 * Shipment method
 * @nullable
 */
export type TrackingResultDtoMethod = ShipmentMethod | null;

export interface TrackingResultDto {
    /** Tracking number */
    trackingNumber: string;
    /**
     * Current tracking status
     * @nullable
     */
    status: TrackingResultDtoStatus;
    /**
     * Detailed status description
     * @nullable
     */
    statusDetails: string | null;
    /**
     * Shipment method
     * @nullable
     */
    method: TrackingResultDtoMethod;
    /**
     * Last event identifier
     * @nullable
     */
    lastEventId: string | null;
    /**
     * Last known location
     * @nullable
     */
    lastLocation: string | null;
    /**
     * Last update timestamp
     * @nullable
     */
    lastUpdated: string | null;
    /**
     * Total number of pieces
     * @nullable
     */
    piecesTotal: number | null;
    /** Link to carrier tracking page */
    trackingLink: string;
    /**
     * Estimated delivery date
     * @nullable
     */
    estimatedDelivery: string | null;
    /**
     * Actual delivery date
     * @nullable
     */
    deliveryDate: string | null;
    /**
     * Carrier name
     * @nullable
     */
    carrierName: string | null;
}

export enum GenerateApiKeyDtoScopesItem {
    'bp:cost-prices' = 'bp:cost-prices',
    'bp:payments' = 'bp:payments',
    'bp:internal-systems' = 'bp:internal-systems',
    'bp:sap:prod-app-users' = 'bp:sap:prod-app-users',
    'notifications:write' = 'notifications:write'
}
export interface GenerateApiKeyDto {
    /**
     * Friendly name for the API key
     * @minLength 10
     * @maxLength 100
     */
    name: string;
    /**
     * Requested scopes/permissions for this API key
     * @minItems 1
     */
    scopes: GenerateApiKeyDtoScopesItem[];
}

export interface GenerateApiKeySimpleDto {
    /**
     * Friendly name for the API key
     * @minLength 10
     * @maxLength 100
     */
    name: string;
}

export enum ApiKeyDtoScopesItem {
    'bp:cost-prices' = 'bp:cost-prices',
    'bp:payments' = 'bp:payments',
    'bp:internal-systems' = 'bp:internal-systems',
    'bp:sap:prod-app-users' = 'bp:sap:prod-app-users',
    'notifications:write' = 'notifications:write'
}
export interface ApiKeyDto {
    /** Unique identifier for the API key */
    id: string;
    /** Friendly name for the API key */
    name: string;
    /** Key hint for identification (e.g., bp_ops_hub_...abc123) */
    keyHint: string;
    /** Scopes assigned to this key */
    scopes: ApiKeyDtoScopesItem[];
    /** Whether the key is active */
    isActive: boolean;
    /** When the key was created */
    createdAt: string;
    /** When the key was last used */
    lastUsedAt?: string;
    /** When the key was revoked */
    revokedAt?: string;
    /** When the key expires */
    expiresAt: string;
}

export interface AssetRef {
    [key: string]: unknown;
}

export interface SendProjectNotificationInternalFeaturesDto {
    /** Tag onsite checkin users */
    tagOnsiteCheckin?: boolean;
    /** Tag remote checkin users */
    tagRemoteCheckin?: boolean;
    /** Tag L3 developers */
    tagL3Developer?: boolean;
}

/**
 * Feature flags for tagging users
 */
export type SendProjectNotificationInternalDtoFeatures = SendProjectNotificationInternalFeaturesDto & {
    /** Tag onsite checkin users */
    tagOnsiteCheckin?: boolean;
    /** Tag remote checkin users */
    tagRemoteCheckin?: boolean;
    /** Tag L3 developers */
    tagL3Developer?: boolean;
};

export enum SendProjectNotificationInternalDtoTargetsItem {
    primary = 'primary',
    level1 = 'level1',
    level3 = 'level3',
    alerts = 'alerts',
    notifications = 'notifications',
    escalation = 'escalation',
    'cross-project' = 'cross-project'
}
export interface SendProjectNotificationInternalDto {
    /** Project code (e.g., vppg01 or VPPG-01) */
    projectCode: string;
    /**
     * Text message to send
     * @minLength 1
     */
    textMessage: string;
    /** Feature flags for tagging users */
    features?: SendProjectNotificationInternalDtoFeatures;
    /**
     * Notification targets (ProjectSpaceType values + escalation + cross-project)
     * @minItems 1
     */
    targets: SendProjectNotificationInternalDtoTargetsItem[];
}

/**
 * Spare part item information
 */
export type ConsumeSparePartsDtoItem = {
    /** ERP part number */
    partNumber: string;
    /**
     * Source bin absolute entry number
     * @minimum 1
     */
    fromBin: number;
    /** Whether the part is damaged irreversibly */
    isDamagedIrreversibly: boolean;
};

/**
 * Warehouse purpose of the source inventory. Defaults to SPARE_PARTS (project local). Use SERVIS for employee inventory.
 */
export enum ConsumeSparePartsDtoFromWarehousePurpose {
    DEFAULT = 'DEFAULT',
    SPARE_PARTS = 'SPARE_PARTS',
    SERVIS = 'SERVIS'
}
export interface ConsumeSparePartsDto {
    /**
     * Normalized project code (6 characters: 4 letters + 2 digits)
     * @minLength 6
     * @maxLength 6
     */
    projectCode: string;
    /**
     * Reason for consuming the spare part
     * @minLength 10
     * @maxLength 200
     */
    reason: string;
    /**
     * Asset reference (Jira key) for the asset the spare part is being consumed for (omit if not asset-specific)
     * @minLength 1
     * @pattern ^(AMR|ADD|CD|INTU)-\d+$
     */
    assetRef?: string;
    /** Spare part item information */
    item: ConsumeSparePartsDtoItem;
    /** Additional comments */
    comment?: string;
    /** Warehouse purpose of the source inventory. Defaults to SPARE_PARTS (project local). Use SERVIS for employee inventory. */
    fromWarehousePurpose?: ConsumeSparePartsDtoFromWarehousePurpose;
}

/**
 * State of the ERP document
 */
export enum ConsumeSparePartsResultDtoState {
    PENDING = 'PENDING',
    ASSIGNED = 'ASSIGNED'
}
/**
 * Instruction for the operator on where to place the consumed part
 */
export enum ConsumeSparePartsResultDtoInstruction {
    QUARANTINE = 'QUARANTINE',
    SCRAP = 'SCRAP'
}
export interface ConsumeSparePartsResultDto {
    /** State of the ERP document */
    state: ConsumeSparePartsResultDtoState;
    /**
     * ERP document reference string (only available when state is assigned)
     * @nullable
     */
    erpDocumentRef?: string | null;
    /** Instruction for the operator on where to place the consumed part */
    instruction: ConsumeSparePartsResultDtoInstruction;
}

/**
 * Priority level for the request
 */
export enum RequestSparePartsDtoPriority {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH'
}
export type RequestSparePartsDtoLinesItem = {
    /** partnumber */
    partNumber?: string;
    /** Item description */
    itemDescription?: string;
    /** Quantity to request */
    quantity?: number;
    /**
     * Optional note
     * @nullable
     */
    freeText?: string | null;
};

export interface RequestSparePartsDto {
    /**
     * Normalized project code (6 characters)
     * @minLength 6
     * @maxLength 6
     */
    projectCode: string;
    /** Document due date (ISO format, must be future date) */
    docDueDate: string;
    /**
     * Subject/reason for the spare parts request
     * @minLength 1
     */
    subject: string;
    /** Priority level for the request */
    priority?: RequestSparePartsDtoPriority;
    /** Additional comments */
    comments?: string;
    /**
     * Line items to request
     * @minItems 1
     */
    lines: RequestSparePartsDtoLinesItem[];
}

export interface RequestSparePartsResponseDto {
    /** Whether the request was successful */
    success: boolean;
    /** Human-readable message about the request status */
    message: string;
    /** Whether the request is pending approval */
    pendingApproval: boolean;
    /** Internal submission ID for tracking */
    submissionId: string;
    /** ERP document handles created by this request */
    documents: string[];
}

export interface ConfirmDeliveryDto {
    /**
     * Normalized project code (6 characters: 4 letters + 2 digits)
     * @minLength 6
     * @maxLength 6
     */
    projectCode: string;
    /**
     * ERP document reference string identifying the shipment
     * @minLength 1
     */
    erpDocRef: string;
    /**
     * Optional note about the delivery confirmation
     * @maxLength 500
     */
    note?: string;
}

export interface ConfirmDeliveryResponseDto {
    /** Whether the confirmation was successful */
    success: boolean;
    /**
     * Error code if the confirmation failed
     * @nullable
     */
    error?: string | null;
    /** Human-readable message about the result */
    message: string;
    /** List of ERP document references affected by the confirmation */
    erpDocRefs?: string[];
}

export type TransferSparePartsDtoItemsItem = {
    /** ERP part number */
    partNumber?: string;
    /**
     * Quantity to transfer
     * @minimum 1
     */
    quantity?: number;
};

export interface TransferSparePartsDto {
    /**
     * Source project code (where parts are shipped from)
     * @minLength 6
     * @maxLength 6
     */
    sourceProjectCode: string;
    /**
     * Destination project code (where parts are shipped to)
     * @minLength 6
     * @maxLength 6
     */
    destinationProjectCode: string;
    /**
     * Items to transfer
     * @minItems 1
     */
    items: TransferSparePartsDtoItemsItem[];
    /**
     * Carrier name (e.g. DHL, FedEx, Internal)
     * @maxLength 100
     */
    carrier?: string;
    /**
     * Tracking number for the shipment
     * @maxLength 100
     */
    trackingNumber?: string;
    /**
     * Free-text comment or note for the transfer
     * @maxLength 500
     */
    comment?: string;
}

/**
 * ERP document reference for the inventory transfer
 * @nullable
 */
export type TransferSparePartsResponseDtoErpDocumentRef = { [key: string]: unknown } | null;

export interface TransferSparePartsResponseDto {
    /** Whether the transfer was successful */
    success: boolean;
    /** Human-readable result message */
    message: string;
    /**
     * ERP document reference for the inventory transfer
     * @nullable
     */
    erpDocumentRef?: TransferSparePartsResponseDtoErpDocumentRef;
    /** Number of distinct items transferred */
    itemCount: number;
}

export interface InventoryItem {
    /** Part number (value object) */
    partNumber: string;
    /** Item description */
    name?: string;
    /** Manufacturer name */
    manufacturer?: string;
    /** Manufacturer Part Number */
    mpn?: string;
    /** Link to documentation or datasheet */
    documentationLink?: string;
    /** Whether item is 3D printed */
    is3DPrinted: boolean;
    /** Whether item is deprecated/obsolete */
    isDeprecated: boolean;
    /** Whether item is frozen/inactive */
    isFrozen: boolean;
    /** Manufacturing/machining type classification */
    manufacturingType?: string;
    /** Quantity on hand at the warehouse */
    onHand: number;
    /** Minimum stock threshold */
    minThreshold?: number;
    /** Maximum stock threshold */
    maxThreshold?: number;
    /** Quantity in quarantine zone (for project warehouses) */
    quarantineQty?: number;
}

export interface InventoryResponseDto {
    /** List of inventory items */
    items: InventoryItem[];
    /** Warehouse code */
    warehouse: string;
    /** Total number of items */
    totalCount: number;
}

export interface ProjectShippingAddressDto {
    /** Street address line 1 */
    street1: string;
    /** Street address line 2 */
    street2?: string;
    /** City */
    city: string;
    /** State/Province */
    state: string;
    /** Postal/ZIP code */
    postalCode: string;
    /** Country code (ISO 3166-1 alpha-2) */
    country: string;
}

export interface ProjectContactDto {
    /** Contact person name */
    name: string;
    /** Contact email */
    email?: string;
    /** Contact phone number */
    phone?: string;
}

export interface ResponsiblePersonDto {
    /** Employee ID in ERP */
    employeeId: number;
    /** Full name */
    name: string;
    /** Email address */
    email?: string;
}

export interface EligibleProjectDto {
    /** Project code */
    projectCode: string;
    /** Facility code (human-readable) */
    facilityCode: string;
    /** Project name */
    name: string;
    /** Shipping address for the project */
    shippingAddress?: ProjectShippingAddressDto;
    /** Primary contact for the project */
    contact?: ProjectContactDto;
    /** Date of last inventory check */
    lastInventoryCheck?: string;
    /** Person responsible for inventory management */
    responsiblePerson?: ResponsiblePersonDto;
    /** ERP entity code (SK or US) */
    entityCode: string;
}

export interface EligibleProjectsResponseDto {
    /** List of eligible projects */
    projects: EligibleProjectDto[];
    /** Total number of eligible projects */
    totalCount: number;
    /**
     * Project code autodetected from request public IP
     * @nullable
     */
    autoDetectedLocation?: string | null;
}

/**
 * Asset type
 */
export enum FacilityAssetDtoType {
    AMR = 'AMR',
    ADDON = 'ADDON',
    CD = 'CD',
    INTU = 'INTU'
}
export interface FacilityAssetDto {
    /** Asset reference (Jira key) */
    ref: string;
    /** Asset summary/name */
    summary: string;
    /** Asset serial number */
    serial: string;
    /** Asset type */
    type: FacilityAssetDtoType;
    /** Robot name (for AMRs) */
    name?: string;
    /** Project code this asset belongs to */
    projectCode: string;
    /** Name of AMR this addon is mounted on (for ADDONs only) */
    mountedOnName?: string;
    /** URL to open the asset in the asset management system */
    linkUrl: string;
    /** Product reference (part number of the asset) */
    productRef?: string;
}

export interface FacilityAssetsResponseDto {
    /** Facility code (first 4 letters of project codes) */
    facilityCode: string;
    /** List of project codes included in this response (all projects sharing the facility) */
    includedProjects: string[];
    /** List of assets in the facility */
    assets: FacilityAssetDto[];
    /** Total number of assets */
    totalCount: number;
}

/**
 * Warehouse reference (includes entity, purpose, etc.)
 */
export type WarehouseInventoryDtoWarehouseRef = { [key: string]: unknown };

/**
 * Average price in the warehouse
 */
export type WarehouseInventoryDtoAveragePrice = { [key: string]: unknown };

export interface WarehouseInventoryDto {
    /** Warehouse reference (includes entity, purpose, etc.) */
    warehouseRef: WarehouseInventoryDtoWarehouseRef;
    /** Quantity on hand */
    onHand: number;
    /** Average price in the warehouse */
    averagePrice?: WarehouseInventoryDtoAveragePrice;
}

export interface PartAvailabilityDto {
    /** Part number */
    partNumber: string;
    /** Part description/name */
    description?: string;
    /** Stock information across warehouses */
    warehouses: WarehouseInventoryDto[];
}

export interface PartsAvailabilityResponseDto {
    /** Availability information for each requested part */
    parts: PartAvailabilityDto[];
    /** Total number of parts in response */
    totalCount: number;
}

export interface SearchPartDto {
    /** Part number */
    partNumber: string;
    /** Part name/description */
    name: string;
    /** Manufacturer name */
    manufacturer?: string;
    /** Manufacturer Part Number */
    mpn?: string;
    /** Link to documentation or datasheet */
    documentationLink?: string;
    /** Whether item is 3D printed */
    is3DPrinted: boolean;
    /** Whether item is deprecated/obsolete */
    isDeprecated: boolean;
    /** Whether item is frozen/inactive (not usable) */
    isFrozen: boolean;
    /** Manufacturing/machining type classification */
    manufacturingType?: string;
    /** Alternative part numbers (for deprecated items) */
    alternativePartNumbers?: string[];
}

export interface SearchPartsResponseDto {
    /** List of matching spare parts */
    parts: SearchPartDto[];
    /** Total number of matching parts */
    totalCount: number;
}

export interface PartNumber {
    [key: string]: unknown;
}

/**
 * Email of the person who consumed the part
 * @nullable
 */
export type ConsumptionHistoryItemDtoConsumedBy = { [key: string]: unknown } | null;

/**
 * Name of the person who consumed the part
 * @nullable
 */
export type ConsumptionHistoryItemDtoConsumedByName = { [key: string]: unknown } | null;

/**
 * Avatar URL of the person who consumed the part
 * @nullable
 */
export type ConsumptionHistoryItemDtoConsumedByAvatarUrl = { [key: string]: unknown } | null;

/**
 * Reason for consumption
 * @nullable
 */
export type ConsumptionHistoryItemDtoReason = { [key: string]: unknown } | null;

/**
 * Asset reference if applicable
 * @nullable
 */
export type ConsumptionHistoryItemDtoAsset = { [key: string]: unknown } | null;

/**
 * Instruction for handling the consumed part
 */
export enum ConsumptionHistoryItemDtoInstruction {
    SCRAP = 'SCRAP',
    QUARANTINE = 'QUARANTINE'
}
/**
 * ERP document reference
 * @nullable
 */
export type ConsumptionHistoryItemDtoErpDocRef = { [key: string]: unknown } | null;

export interface ConsumptionHistoryItemDto {
    /** Unique identifier for the consumption record */
    id: string;
    /** Date and time when the part was consumed (ISO 8601) */
    consumedAt: string;
    /**
     * Email of the person who consumed the part
     * @nullable
     */
    consumedBy: ConsumptionHistoryItemDtoConsumedBy;
    /**
     * Name of the person who consumed the part
     * @nullable
     */
    consumedByName: ConsumptionHistoryItemDtoConsumedByName;
    /**
     * Avatar URL of the person who consumed the part
     * @nullable
     */
    consumedByAvatarUrl: ConsumptionHistoryItemDtoConsumedByAvatarUrl;
    /** Part number */
    partNumber: PartNumber;
    /** Part name/description */
    partName: string;
    /** Quantity consumed */
    quantity: number;
    /**
     * Reason for consumption
     * @nullable
     */
    reason: ConsumptionHistoryItemDtoReason;
    /**
     * Asset reference if applicable
     * @nullable
     */
    asset: ConsumptionHistoryItemDtoAsset;
    /** Instruction for handling the consumed part */
    instruction: ConsumptionHistoryItemDtoInstruction;
    /**
     * ERP document reference
     * @nullable
     */
    erpDocRef: ConsumptionHistoryItemDtoErpDocRef;
}

export type ConsumptionHistoryResponseDtoItemsItemConsumedBy = string | null;

export type ConsumptionHistoryResponseDtoItemsItemConsumedByName = string | null;

export type ConsumptionHistoryResponseDtoItemsItemConsumedByAvatarUrl = string | null;

export type ConsumptionHistoryResponseDtoItemsItemReason = string | null;

export type ConsumptionHistoryResponseDtoItemsItemAsset = string | null;

export enum ConsumptionHistoryResponseDtoItemsItemInstruction {
    SCRAP = 'SCRAP',
    QUARANTINE = 'QUARANTINE'
}
export type ConsumptionHistoryResponseDtoItemsItemErpDocRef = string | null;

export type ConsumptionHistoryResponseDtoItemsItem = {
    id: string;
    /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
    consumedAt: string;
    consumedBy: ConsumptionHistoryResponseDtoItemsItemConsumedBy;
    consumedByName: ConsumptionHistoryResponseDtoItemsItemConsumedByName;
    consumedByAvatarUrl: ConsumptionHistoryResponseDtoItemsItemConsumedByAvatarUrl;
    partNumber: string;
    partName: string;
    quantity: number;
    reason: ConsumptionHistoryResponseDtoItemsItemReason;
    asset: ConsumptionHistoryResponseDtoItemsItemAsset;
    instruction: ConsumptionHistoryResponseDtoItemsItemInstruction;
    erpDocRef: ConsumptionHistoryResponseDtoItemsItemErpDocRef;
};

export interface ConsumptionHistoryResponseDto {
    /** List of consumption history items */
    items: ConsumptionHistoryResponseDtoItemsItem[];
    /** Total number of records matching the query */
    total: number;
}

export interface RecountItemDto {
    /** Part number */
    partNumber: PartNumber;
    /** Expected spare parts quantity (from system) */
    expectedSpareQty: number;
    /** Counted spare parts quantity (physical count) */
    countedSpareQty: number;
    /** Expected quarantine quantity (from system) */
    expectedQuarantineQty: number;
    /** Counted quarantine quantity (physical count) */
    countedQuarantineQty: number;
}

export type SubmitRecountDtoItemsItem = {
    partNumber: string;
    /**
     * @minimum 0
     * @maximum 9007199254740991
     */
    expectedSpareQty: number;
    /**
     * @minimum 0
     * @maximum 9007199254740991
     */
    countedSpareQty: number;
    /**
     * @minimum 0
     * @maximum 9007199254740991
     */
    expectedQuarantineQty: number;
    /**
     * @minimum 0
     * @maximum 9007199254740991
     */
    countedQuarantineQty: number;
};

export interface SubmitRecountDto {
    /** Project code */
    projectCode: string;
    /**
     * List of counted items
     * @minItems 1
     */
    items: SubmitRecountDtoItemsItem[];
    /**
     * Optional comment about the recount
     * @maxLength 1000
     */
    comment?: string;
}

export interface RecountSummaryDto {
    /** Total number of items counted */
    totalCounted: number;
    /** Number of items that matched expected quantities */
    matched: number;
    /** Number of items with discrepancies */
    discrepancies: number;
}

export interface SubmitRecountResponseDto {
    /** Unique identifier for this recount session */
    recountId: string;
    /** Timestamp when the recount was submitted */
    submittedAt: string;
    /** Summary of the recount results */
    summary: RecountSummaryDto;
    /** Jira issue IDs created for discrepancies */
    discrepancyIssueIds?: string[];
}

export enum ProjectOrdersResponseDtoOrdersItemPriority {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH'
}
export enum ProjectOrdersResponseDtoOrdersItemStatus {
    pending = 'pending',
    approved = 'approved',
    denied = 'denied',
    partially_shipped = 'partially_shipped',
    shipped = 'shipped',
    delivered = 'delivered'
}
export type ProjectOrdersResponseDtoOrdersItemItemsItem = {
    partNumber?: string;
    name?: string;
    quantity?: number;
};

export type ProjectOrdersResponseDtoOrdersItem = {
    erpDocumentRef?: string;
    submittedAt?: string;
    submittedBy?: string;
    subject?: string;
    priority?: ProjectOrdersResponseDtoOrdersItemPriority;
    status?: ProjectOrdersResponseDtoOrdersItemStatus;
    itemCount?: number;
    items?: ProjectOrdersResponseDtoOrdersItemItemsItem[];
};

export enum ProjectOrdersResponseDtoShipmentsItemStatus {
    shipped = 'shipped',
    delivered = 'delivered',
    confirmed = 'confirmed'
}
export type ProjectOrdersResponseDtoShipmentsItemItemsItem = {
    partNumber?: string;
    name?: string;
    quantity?: number;
    orderId?: string;
};

export type ProjectOrdersResponseDtoShipmentsItem = {
    erpDocumentRef?: string;
    trackingNumber?: string;
    carrier?: string;
    status?: ProjectOrdersResponseDtoShipmentsItemStatus;
    /** @nullable */
    subject?: string | null;
    submittedBy?: string;
    shippedAt?: string;
    /** @nullable */
    estimatedDelivery?: string | null;
    /** @nullable */
    deliveredAt?: string | null;
    /** @nullable */
    confirmedAt?: string | null;
    items?: ProjectOrdersResponseDtoShipmentsItemItemsItem[];
};

export interface ProjectOrdersResponseDto {
    /** List of spare parts orders (Sales Orders) */
    orders: ProjectOrdersResponseDtoOrdersItem[];
    /** List of shipments (Delivery Notes and Inventory Transfers) */
    shipments: ProjectOrdersResponseDtoShipmentsItem[];
}

/**
 * Type of issue being reported
 */
export enum ReportPartIssueDtoIssueType {
    wrong_image = 'wrong_image',
    wrong_name = 'wrong_name',
    wrong_manufacturer = 'wrong_manufacturer',
    wrong_docs = 'wrong_docs',
    wrong_categorization = 'wrong_categorization',
    missing_alternative = 'missing_alternative',
    should_be_frozen = 'should_be_frozen',
    should_be_deprecated = 'should_be_deprecated',
    other = 'other'
}
export interface ReportPartIssueDto {
    /**
     * The part number being reported
     * @minLength 1
     * @maxLength 50
     */
    partNumber: string;
    /** Type of issue being reported */
    issueType: ReportPartIssueDtoIssueType;
    /**
     * Additional details about the issue
     * @maxLength 500
     */
    description?: string;
    /**
     * Context where the issue was found (for analytics)
     * @maxLength 50
     */
    source?: string;
}

/**
 * Status of the issue
 */
export enum ReportPartIssueResponseDtoStatus {
    submitted = 'submitted'
}
export interface ReportPartIssueResponseDto {
    /** Unique ID of the created issue report (Jira issue key) */
    issueId: string;
    /** Timestamp when the issue was recorded */
    createdAt: string;
    /** Status of the issue */
    status: ReportPartIssueResponseDtoStatus;
}

/**
 * Type of issue being reported
 */
export enum ReportProjectIssueDtoIssueType {
    wrong_address = 'wrong_address',
    wrong_contact = 'wrong_contact',
    wrong_timezone = 'wrong_timezone',
    wrong_contract_info = 'wrong_contract_info',
    wrong_team_member = 'wrong_team_member',
    wrong_customer_info = 'wrong_customer_info',
    missing_info = 'missing_info',
    outdated_info = 'outdated_info',
    other = 'other'
}
export interface ReportProjectIssueDto {
    /** Project code */
    projectCode: string;
    /** Type of issue being reported */
    issueType: ReportProjectIssueDtoIssueType;
    /**
     * The specific field that has an issue
     * @maxLength 100
     */
    field?: string;
    /**
     * The current incorrect value
     * @maxLength 500
     */
    currentValue?: string;
    /**
     * The expected correct value
     * @maxLength 500
     */
    expectedValue?: string;
    /**
     * Additional details about the issue
     * @maxLength 500
     */
    description?: string;
    /**
     * Context where the issue was found
     * @maxLength 50
     */
    source?: string;
}

/**
 * Status of the issue
 */
export enum ReportProjectIssueResponseDtoStatus {
    submitted = 'submitted'
}
export interface ReportProjectIssueResponseDto {
    /** Unique ID of the created issue report (Jira issue key) */
    issueId: string;
    /** Timestamp when the issue was recorded */
    createdAt: string;
    /** Status of the issue */
    status: ReportProjectIssueResponseDtoStatus;
}

/**
 * Zone/location where the discrepancy was found
 */
export enum ReportInventoryDiscrepancyDtoZone {
    spare_parts = 'spare_parts',
    quarantine = 'quarantine',
    scrap = 'scrap',
    other = 'other'
}
export interface ReportInventoryDiscrepancyDto {
    /** Project code where the discrepancy was found */
    projectCode: string;
    /** Part number with the discrepancy */
    partNumber: string;
    /**
     * Expected quantity (what the system shows)
     * @minimum 0
     * @maximum 9007199254740991
     */
    expectedQuantity: number;
    /**
     * Actual quantity (what was physically counted)
     * @minimum 0
     * @maximum 9007199254740991
     */
    actualQuantity: number;
    /** Zone/location where the discrepancy was found */
    zone?: ReportInventoryDiscrepancyDtoZone;
    /**
     * Additional details about the discrepancy
     * @maxLength 500
     */
    description?: string;
    /**
     * Context where the discrepancy was found
     * @maxLength 50
     */
    source?: string;
}

/**
 * Status of the issue
 */
export enum ReportInventoryDiscrepancyResponseDtoStatus {
    submitted = 'submitted'
}
export interface ReportInventoryDiscrepancyResponseDto {
    /** Unique ID of the created issue report (Jira issue key) */
    issueId: string;
    /** Timestamp when the issue was recorded */
    createdAt: string;
    /** Status of the issue */
    status: ReportInventoryDiscrepancyResponseDtoStatus;
}

/**
 * Status of the issue
 */
export enum ReportShipmentProblemResponseDtoStatus {
    submitted = 'submitted'
}
export interface ReportShipmentProblemResponseDto {
    /** Unique ID of the created issue report (Jira issue key) */
    issueId: string;
    /** Timestamp when the issue was recorded */
    createdAt: string;
    /** Status of the issue */
    status: ReportShipmentProblemResponseDtoStatus;
}

export interface EntityDto {
    /** Entity code */
    code: string;
    /** Entity display name */
    name: string;
}

/**
 * Auto-detected entity code based on client geolocation
 * @nullable
 */
export type EntitiesResponseDtoAutoDetect = { [key: string]: unknown } | null;

export interface EntitiesResponseDto {
    entities: EntityDto[];
    /**
     * Auto-detected entity code based on client geolocation
     * @nullable
     */
    autoDetect?: EntitiesResponseDtoAutoDetect;
}

export interface ProjectDto {
    /** SAP project code */
    projectCode: string;
    /** Project name */
    name: string;
}

export interface ProjectsResponseDto {
    projects: ProjectDto[];
}

export interface CostingDimensionDto {
    /** Dimension code */
    code: string;
    /** Dimension name */
    name: string;
}

export interface CostingDimensionsResponseDto {
    dimensions: CostingDimensionDto[];
    /** Which dimension number these belong to */
    dimension: number;
}

export interface BudgetDto {
    /** Budget code */
    code: string;
    /** Budget name */
    name: string;
}

export interface BudgetsResponseDto {
    budgets: BudgetDto[];
}

export interface CategoryDto {
    /** Category name (item property display name) */
    name: string;
}

export interface CategoriesResponseDto {
    categories: CategoryDto[];
}

export interface StockLevelDto {
    /** Entity code */
    entity: string;
    /** Entity label */
    label: string;
    /** Total on-hand quantity */
    inStock: number;
    /** Committed quantity */
    committed: number;
    /** Available quantity (inStock - committed) */
    available: number;
}

/**
 * Currency (requires bp:cost-prices scope)
 */
export enum CatalogItemDtoCurrency {
    EUR = 'EUR',
    USD = 'USD'
}
export interface CatalogItemDto {
    /** Part number */
    partNumber: string;
    /** Part name */
    name: string;
    /** Manufacturer */
    manufacturer?: string;
    /** Manufacturer Part Number */
    mpn?: string;
    /** Unit price (requires bp:cost-prices scope) */
    unitPrice?: number;
    /** Currency (requires bp:cost-prices scope) */
    currency?: CatalogItemDtoCurrency;
    /** Unit of measure */
    uom?: string;
    /** Item categories (from item properties) */
    categories?: string[];
    /** Item is deprecated/obsolete */
    isDeprecated: boolean;
    /** Item is frozen/inactive */
    isFrozen: boolean;
    /** Item is 3D printed */
    is3DPrinted: boolean;
    /** Alternative part numbers (for deprecated items) */
    alternativePartNumbers?: string[];
    /** Stock levels per entity */
    stockLevels: StockLevelDto[];
}

export interface CatalogResponseDto {
    items: CatalogItemDto[];
    /** Total number of items */
    totalCount: number;
    /** Available categories for filtering */
    categories?: string[];
}

/**
 * @nullable
 */
export type PurchaseRequestLineDtoProjectCode = { [key: string]: unknown } | null;

export interface PurchaseRequestLineDto {
    lineNum: number;
    partNumber: string;
    name: string;
    quantity: number;
    openQty: number;
    /** Unit price (requires bp:cost-prices scope) */
    unitPrice?: number;
    /** Line total (requires bp:cost-prices scope) */
    lineTotal?: number;
    /** Currency (requires bp:cost-prices scope) */
    currency?: string;
    /** @nullable */
    projectCode: PurchaseRequestLineDtoProjectCode;
}

export enum PurchaseRequestItemDtoStatus {
    open = 'open',
    closed = 'closed',
    cancelled = 'cancelled'
}
export type PurchaseRequestItemDtoSubject = { [key: string]: unknown };

/**
 * @nullable
 */
export type PurchaseRequestItemDtoProjectCode = { [key: string]: unknown } | null;

export interface PurchaseRequestItemDto {
    erpDocRef: string;
    docDate: string;
    requiredDate?: string;
    /** Last update date (ISO) */
    lastUpdate?: string;
    status: PurchaseRequestItemDtoStatus;
    subject?: PurchaseRequestItemDtoSubject;
    submittedBy: string;
    /** @nullable */
    projectCode?: PurchaseRequestItemDtoProjectCode;
    /** Total amount (requires bp:cost-prices scope) */
    totalAmount?: number;
    /** Currency (requires bp:cost-prices scope) */
    currency?: string;
    lines: PurchaseRequestLineDto[];
}

export interface PurchaseRequestsResponseDto {
    documents: PurchaseRequestItemDto[];
}

export enum CreatePurchaseRequestInputDtoEntity {
    SK = 'SK',
    US = 'US'
}
export type CreatePurchaseRequestInputDtoLinesItem = {
    partNumber?: string;
    quantity?: number;
    unitPrice?: number;
    currency?: string;
    description?: string;
    projectCode?: string;
    costingCode?: string;
    costingCode2?: string;
    costingCode3?: string;
    purpose?: string;
    link?: string;
    manufacturer?: string;
};

export interface CreatePurchaseRequestInputDto {
    entity: CreatePurchaseRequestInputDtoEntity;
    /** @minLength 1 */
    subject: string;
    /**
     * Required date (ISO date string)
     * @minLength 1
     */
    requiredDate: string;
    projectCode?: string;
    comments?: string;
    /** @minItems 1 */
    lines: CreatePurchaseRequestInputDtoLinesItem[];
}

export interface CreatePurchaseRequestResponseDto {
    success: boolean;
    message: string;
    /** Whether the document is still pending ERP assignment */
    pending: boolean;
    /** ERP doc ref (only when assigned) */
    erpDocRef?: string;
    /** ERP doc number (only when assigned) */
    docNum?: number;
    /** Internal submission ID (always available) */
    submissionId: string;
}

export interface SourceDocRefDto {
    erpDocRef: string;
    type: string;
}

/**
 * @nullable
 */
export type PurchaseOrderLineDtoProjectCode = { [key: string]: unknown } | null;

export interface PurchaseOrderLineDto {
    lineNum: number;
    partNumber: string;
    name: string;
    quantity: number;
    openQty: number;
    /** Unit price (requires bp:cost-prices scope) */
    unitPrice?: number;
    /** Line total (requires bp:cost-prices scope) */
    lineTotal?: number;
    /** Currency (requires bp:cost-prices scope) */
    currency?: string;
    /** @nullable */
    projectCode: PurchaseOrderLineDtoProjectCode;
    sourcePurchaseRequests: SourceDocRefDto[];
}

export enum PurchaseOrderItemDtoStatus {
    open = 'open',
    closed = 'closed',
    cancelled = 'cancelled'
}
/**
 * @nullable
 */
export type PurchaseOrderItemDtoSubject = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PurchaseOrderItemDtoProjectCode = { [key: string]: unknown } | null;

export interface PurchaseOrderItemDto {
    erpDocRef: string;
    docDate: string;
    dueDate?: string;
    /** Last update date (ISO) */
    lastUpdate?: string;
    status: PurchaseOrderItemDtoStatus;
    /** @nullable */
    subject?: PurchaseOrderItemDtoSubject;
    vendor: string;
    vendorName: string;
    requestedBy: string;
    /** Purchaser / buyer name (from SlpCode) */
    purchaser?: string;
    /** @nullable */
    projectCode?: PurchaseOrderItemDtoProjectCode;
    /** Total amount (requires bp:cost-prices scope) */
    totalAmount?: number;
    /** Currency (requires bp:cost-prices scope) */
    currency?: string;
    lines: PurchaseOrderLineDto[];
}

export interface PurchaseOrdersResponseDto {
    documents: PurchaseOrderItemDto[];
}

export type ShipmentControllerTrackShipmentParams = {
    /**
     * Tracking number / waybill of the shipment
     */
    trackingNumber: string;
    /**
     * Carrier name (e.g., UPS, DHL, FedEx)
     */
    carrier?: string;
    /**
     * Shipment method (e.g., PARCEL, LTL, DEDICATED)
     */
    method?: string;
};

export type SparePartsControllerGetPartsAvailabilityParams = {
    /**
     * Comma-separated list of part numbers to check availability for
     * @minLength 1
     */
    partNumbers: string;
};

export type SparePartsControllerSearchPartsParams = {
    /**
     * Search term (min 3 characters)
     * @minLength 3
     */
    q: string;
    /**
     * Maximum number of results (default 50, max 200)
     * @minimum 1
     * @maximum 200
     */
    limit?: number;
};

export type SparePartsControllerGetEligiblePartsParams = {
    /**
     * Project code to filter spare parts
     */
    projectCode?: string;
    /**
     * Asset reference to filter spare parts
     * @minLength 1
     * @pattern ^(AMR|ADD|CD|INTU)-\d+$
     */
    assetRef?: string;
    /**
     * Part number to filter spare parts
     */
    partNumber?: string;
    /**
     * Asset serial number to filter spare parts
     */
    assetSerialNumber?: string;
};

export type SparePartsControllerGetConsumptionHistoryParams = {
    /**
     * Start date (ISO 8601 format)
     * @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$
     */
    from?: string;
    /**
     * End date (ISO 8601 format)
     * @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$
     */
    to?: string;
    /**
     * Filter by specific part number
     */
    partNumber?: string;
    /**
     * Maximum number of records (default 100, max 500)
     * @maximum 5000
     */
    limit?: number;
};

export type SparePartsControllerGetProjectOrdersParams = {
    /**
     * Number of months to look back (default: 3, max: 24)
     * @minimum 1
     * @maximum 24
     */
    monthsBack?: number;
};

export enum FeedbackControllerReportShipmentProblemBodyProblemType {
    missing_items = 'missing_items',
    wrong_items = 'wrong_items',
    damaged = 'damaged',
    wrong_quantity = 'wrong_quantity',
    other = 'other'
}
export type FeedbackControllerReportShipmentProblemBody = {
    projectCode: string;
    shipmentRef: string;
    problemType: FeedbackControllerReportShipmentProblemBodyProblemType;
    description?: string;
    source?: string;
    photo?: Blob;
};

export type SupplyHubControllerGetEntitiesParams = {
    tz: string;
};

export type SupplyHubControllerGetProjectsParams = {
    /**
     * Entity code (business unit)
     */
    entity: SupplyHubControllerGetProjectsEntity;
};

export enum SupplyHubControllerGetProjectsEntity {
    SK = 'SK',
    US = 'US'
}
export type SupplyHubControllerGetCostingDimensionsParams = {
    /**
     * Entity code
     */
    entity: SupplyHubControllerGetCostingDimensionsEntity;
    /**
     * Dimension number (1-5)
     * @minimum 1
     * @maximum 5
     */
    dimension: number;
};

export enum SupplyHubControllerGetCostingDimensionsEntity {
    SK = 'SK',
    US = 'US'
}
export type SupplyHubControllerGetBudgetsParams = {
    /**
     * Entity code (business unit)
     */
    entity: SupplyHubControllerGetBudgetsEntity;
};

export enum SupplyHubControllerGetBudgetsEntity {
    SK = 'SK',
    US = 'US'
}
export type SupplyHubControllerGetCategoriesParams = {
    /**
     * Entity code (business unit)
     */
    entity: SupplyHubControllerGetCategoriesEntity;
};

export enum SupplyHubControllerGetCategoriesEntity {
    SK = 'SK',
    US = 'US'
}
export type SupplyHubControllerGetCatalogParams = {
    /**
     * Entity code
     */
    entity: SupplyHubControllerGetCatalogEntity;
    /**
     * Search term (min 2 chars)
     * @minLength 2
     */
    search?: string;
    /**
     * Filter by item category/group
     */
    category?: string;
    /**
     * Exclude deprecated items
     */
    skipDeprecated?: SupplyHubControllerGetCatalogSkipDeprecated;
    /**
     * Exclude frozen/inactive items
     */
    skipFrozen?: SupplyHubControllerGetCatalogSkipFrozen;
};

export enum SupplyHubControllerGetCatalogEntity {
    SK = 'SK',
    US = 'US'
}
export enum SupplyHubControllerGetCatalogSkipDeprecated {
    true = 'true',
    false = 'false'
}
export enum SupplyHubControllerGetCatalogSkipFrozen {
    true = 'true',
    false = 'false'
}
export type SupplyHubControllerGetPurchaseRequestsParams = {
    /**
     * Entity code (business unit)
     */
    entity: SupplyHubControllerGetPurchaseRequestsEntity;
};

export enum SupplyHubControllerGetPurchaseRequestsEntity {
    SK = 'SK',
    US = 'US'
}
export type SupplyHubControllerGetPurchaseOrdersParams = {
    /**
     * Entity code (business unit)
     */
    entity: SupplyHubControllerGetPurchaseOrdersEntity;
};

export enum SupplyHubControllerGetPurchaseOrdersEntity {
    SK = 'SK',
    US = 'US'
}
/**
 * @summary Confirm receipt of a shipment
 */
export const shipmentControllerConfirmReceipt = (confirmReceiptDto: ConfirmReceiptDto, signal?: AbortSignal) => {
    return platformAxios<void>({
        url: `/api/shipments/confirm-receipt`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: confirmReceiptDto,
        signal
    });
};

export const getShipmentControllerConfirmReceiptMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof shipmentControllerConfirmReceipt>>,
        TError,
        { data: ConfirmReceiptDto },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<typeof shipmentControllerConfirmReceipt>>, TError, { data: ConfirmReceiptDto }, TContext> => {
    const mutationKey = ['shipmentControllerConfirmReceipt'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof shipmentControllerConfirmReceipt>>, { data: ConfirmReceiptDto }> = (
        props
    ) => {
        const { data } = props ?? {};

        return shipmentControllerConfirmReceipt(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ShipmentControllerConfirmReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof shipmentControllerConfirmReceipt>>>;
export type ShipmentControllerConfirmReceiptMutationBody = ConfirmReceiptDto;
export type ShipmentControllerConfirmReceiptMutationError = void;

/**
 * @summary Confirm receipt of a shipment
 */
export const useShipmentControllerConfirmReceipt = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof shipmentControllerConfirmReceipt>>,
        TError,
        { data: ConfirmReceiptDto },
        TContext
    >;
}): UseMutationResult<Awaited<ReturnType<typeof shipmentControllerConfirmReceipt>>, TError, { data: ConfirmReceiptDto }, TContext> => {
    const mutationOptions = getShipmentControllerConfirmReceiptMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Track a shipment by tracking number
 */
export const shipmentControllerTrackShipment = (params: ShipmentControllerTrackShipmentParams, signal?: AbortSignal) => {
    return platformAxios<TrackingResultDto>({ url: `/api/shipments/track-shipment`, method: 'GET', params, signal });
};

export const getShipmentControllerTrackShipmentQueryKey = (params?: ShipmentControllerTrackShipmentParams) => {
    return [`/api/shipments/track-shipment`, ...(params ? [params] : [])] as const;
};

export const getShipmentControllerTrackShipmentQueryOptions = <
    TData = Awaited<ReturnType<typeof shipmentControllerTrackShipment>>,
    TError = void
>(
    params: ShipmentControllerTrackShipmentParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof shipmentControllerTrackShipment>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getShipmentControllerTrackShipmentQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shipmentControllerTrackShipment>>> = ({ signal }) =>
        shipmentControllerTrackShipment(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof shipmentControllerTrackShipment>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ShipmentControllerTrackShipmentQueryResult = NonNullable<Awaited<ReturnType<typeof shipmentControllerTrackShipment>>>;
export type ShipmentControllerTrackShipmentQueryError = void;

/**
 * @summary Track a shipment by tracking number
 */

export function useShipmentControllerTrackShipment<TData = Awaited<ReturnType<typeof shipmentControllerTrackShipment>>, TError = void>(
    params: ShipmentControllerTrackShipmentParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof shipmentControllerTrackShipment>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getShipmentControllerTrackShipmentQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

export const authControllerGoogleLogin = (signal?: AbortSignal) => {
    return platformAxios<void>({ url: `/api/oauth/google-login`, method: 'POST', signal });
};

export const getAuthControllerGoogleLoginMutationOptions = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerGoogleLogin>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerGoogleLogin>>, TError, void, TContext> => {
    const mutationKey = ['authControllerGoogleLogin'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerGoogleLogin>>, void> = () => {
        return authControllerGoogleLogin();
    };

    return { mutationFn, ...mutationOptions };
};

export type AuthControllerGoogleLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerGoogleLogin>>>;

export type AuthControllerGoogleLoginMutationError = unknown;

export const useAuthControllerGoogleLogin = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerGoogleLogin>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof authControllerGoogleLogin>>, TError, void, TContext> => {
    const mutationOptions = getAuthControllerGoogleLoginMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Generate a new API key for script/automation access
 */
export const authControllerGenerateApiKey = (generateApiKeyDto: GenerateApiKeyDto, signal?: AbortSignal) => {
    return platformAxios<void>({
        url: `/api/oauth/generate-api-key`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateApiKeyDto,
        signal
    });
};

export const getAuthControllerGenerateApiKeyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerGenerateApiKey>>, TError, { data: GenerateApiKeyDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerGenerateApiKey>>, TError, { data: GenerateApiKeyDto }, TContext> => {
    const mutationKey = ['authControllerGenerateApiKey'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerGenerateApiKey>>, { data: GenerateApiKeyDto }> = (props) => {
        const { data } = props ?? {};

        return authControllerGenerateApiKey(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AuthControllerGenerateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerGenerateApiKey>>>;
export type AuthControllerGenerateApiKeyMutationBody = GenerateApiKeyDto;
export type AuthControllerGenerateApiKeyMutationError = unknown;

/**
 * @summary Generate a new API key for script/automation access
 */
export const useAuthControllerGenerateApiKey = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerGenerateApiKey>>, TError, { data: GenerateApiKeyDto }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof authControllerGenerateApiKey>>, TError, { data: GenerateApiKeyDto }, TContext> => {
    const mutationOptions = getAuthControllerGenerateApiKeyMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Generate a new API key inheriting user scopes
 */
export const authControllerGenerateApiKeySimple = (generateApiKeySimpleDto: GenerateApiKeySimpleDto, signal?: AbortSignal) => {
    return platformAxios<void>({
        url: `/api/oauth/api-keys`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateApiKeySimpleDto,
        signal
    });
};

export const getAuthControllerGenerateApiKeySimpleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof authControllerGenerateApiKeySimple>>,
        TError,
        { data: GenerateApiKeySimpleDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof authControllerGenerateApiKeySimple>>,
    TError,
    { data: GenerateApiKeySimpleDto },
    TContext
> => {
    const mutationKey = ['authControllerGenerateApiKeySimple'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof authControllerGenerateApiKeySimple>>,
        { data: GenerateApiKeySimpleDto }
    > = (props) => {
        const { data } = props ?? {};

        return authControllerGenerateApiKeySimple(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AuthControllerGenerateApiKeySimpleMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerGenerateApiKeySimple>>>;
export type AuthControllerGenerateApiKeySimpleMutationBody = GenerateApiKeySimpleDto;
export type AuthControllerGenerateApiKeySimpleMutationError = unknown;

/**
 * @summary Generate a new API key inheriting user scopes
 */
export const useAuthControllerGenerateApiKeySimple = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof authControllerGenerateApiKeySimple>>,
        TError,
        { data: GenerateApiKeySimpleDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof authControllerGenerateApiKeySimple>>,
    TError,
    { data: GenerateApiKeySimpleDto },
    TContext
> => {
    const mutationOptions = getAuthControllerGenerateApiKeySimpleMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary List all API keys for the current user
 */
export const authControllerListApiKeys = (signal?: AbortSignal) => {
    return platformAxios<ApiKeyDto[]>({ url: `/api/oauth/api-keys`, method: 'GET', signal });
};

export const getAuthControllerListApiKeysQueryKey = () => {
    return [`/api/oauth/api-keys`] as const;
};

export const getAuthControllerListApiKeysQueryOptions = <
    TData = Awaited<ReturnType<typeof authControllerListApiKeys>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof authControllerListApiKeys>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAuthControllerListApiKeysQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerListApiKeys>>> = ({ signal }) => authControllerListApiKeys(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof authControllerListApiKeys>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type AuthControllerListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerListApiKeys>>>;
export type AuthControllerListApiKeysQueryError = unknown;

/**
 * @summary List all API keys for the current user
 */

export function useAuthControllerListApiKeys<TData = Awaited<ReturnType<typeof authControllerListApiKeys>>, TError = unknown>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof authControllerListApiKeys>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getAuthControllerListApiKeysQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Revoke an API key
 */
export const authControllerRevokeApiKey = (id: string) => {
    return platformAxios<void>({ url: `/api/oauth/api-keys/${id}`, method: 'DELETE' });
};

export const getAuthControllerRevokeApiKeyMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerRevokeApiKey>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerRevokeApiKey>>, TError, { id: string }, TContext> => {
    const mutationKey = ['authControllerRevokeApiKey'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRevokeApiKey>>, { id: string }> = (props) => {
        const { id } = props ?? {};

        return authControllerRevokeApiKey(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type AuthControllerRevokeApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRevokeApiKey>>>;

export type AuthControllerRevokeApiKeyMutationError = void;

/**
 * @summary Revoke an API key
 */
export const useAuthControllerRevokeApiKey = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerRevokeApiKey>>, TError, { id: string }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof authControllerRevokeApiKey>>, TError, { id: string }, TContext> => {
    const mutationOptions = getAuthControllerRevokeApiKeyMutationOptions(options);

    return useMutation(mutationOptions);
};

export const authControllerGetProfile = (signal?: AbortSignal) => {
    return platformAxios<void>({ url: `/api/oauth/me`, method: 'GET', signal });
};

export const getAuthControllerGetProfileQueryKey = () => {
    return [`/api/oauth/me`] as const;
};

export const getAuthControllerGetProfileQueryOptions = <
    TData = Awaited<ReturnType<typeof authControllerGetProfile>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof authControllerGetProfile>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAuthControllerGetProfileQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetProfile>>> = ({ signal }) => authControllerGetProfile(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetProfile>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type AuthControllerGetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetProfile>>>;
export type AuthControllerGetProfileQueryError = unknown;

export function useAuthControllerGetProfile<TData = Awaited<ReturnType<typeof authControllerGetProfile>>, TError = unknown>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof authControllerGetProfile>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getAuthControllerGetProfileQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Consume spare parts and create ERP stock transfer
 */
export const sparePartsControllerConsumeSpareParts = (consumeSparePartsDto: ConsumeSparePartsDto, signal?: AbortSignal) => {
    return platformAxios<ConsumeSparePartsResultDto>({
        url: `/api/spare-parts/consume-spare-parts`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: consumeSparePartsDto,
        signal
    });
};

export const getSparePartsControllerConsumeSparePartsMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerConsumeSpareParts>>,
        TError,
        { data: ConsumeSparePartsDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sparePartsControllerConsumeSpareParts>>,
    TError,
    { data: ConsumeSparePartsDto },
    TContext
> => {
    const mutationKey = ['sparePartsControllerConsumeSpareParts'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sparePartsControllerConsumeSpareParts>>,
        { data: ConsumeSparePartsDto }
    > = (props) => {
        const { data } = props ?? {};

        return sparePartsControllerConsumeSpareParts(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SparePartsControllerConsumeSparePartsMutationResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerConsumeSpareParts>>
>;
export type SparePartsControllerConsumeSparePartsMutationBody = ConsumeSparePartsDto;
export type SparePartsControllerConsumeSparePartsMutationError = void;

/**
 * @summary Consume spare parts and create ERP stock transfer
 */
export const useSparePartsControllerConsumeSpareParts = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerConsumeSpareParts>>,
        TError,
        { data: ConsumeSparePartsDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sparePartsControllerConsumeSpareParts>>,
    TError,
    { data: ConsumeSparePartsDto },
    TContext
> => {
    const mutationOptions = getSparePartsControllerConsumeSparePartsMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Request spare parts and create ERP Sales Order
 */
export const sparePartsControllerRequestSpareParts = (requestSparePartsDto: RequestSparePartsDto, signal?: AbortSignal) => {
    return platformAxios<RequestSparePartsResponseDto>({
        url: `/api/spare-parts/request-spare-parts`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: requestSparePartsDto,
        signal
    });
};

export const getSparePartsControllerRequestSparePartsMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerRequestSpareParts>>,
        TError,
        { data: RequestSparePartsDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sparePartsControllerRequestSpareParts>>,
    TError,
    { data: RequestSparePartsDto },
    TContext
> => {
    const mutationKey = ['sparePartsControllerRequestSpareParts'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sparePartsControllerRequestSpareParts>>,
        { data: RequestSparePartsDto }
    > = (props) => {
        const { data } = props ?? {};

        return sparePartsControllerRequestSpareParts(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SparePartsControllerRequestSparePartsMutationResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerRequestSpareParts>>
>;
export type SparePartsControllerRequestSparePartsMutationBody = RequestSparePartsDto;
export type SparePartsControllerRequestSparePartsMutationError = void;

/**
 * @summary Request spare parts and create ERP Sales Order
 */
export const useSparePartsControllerRequestSpareParts = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerRequestSpareParts>>,
        TError,
        { data: RequestSparePartsDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sparePartsControllerRequestSpareParts>>,
    TError,
    { data: RequestSparePartsDto },
    TContext
> => {
    const mutationOptions = getSparePartsControllerRequestSparePartsMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Confirm delivery of a shipment at project site
 */
export const sparePartsControllerConfirmDelivery = (confirmDeliveryDto: ConfirmDeliveryDto, signal?: AbortSignal) => {
    return platformAxios<ConfirmDeliveryResponseDto>({
        url: `/api/spare-parts/confirm-delivery`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: confirmDeliveryDto,
        signal
    });
};

export const getSparePartsControllerConfirmDeliveryMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerConfirmDelivery>>,
        TError,
        { data: ConfirmDeliveryDto },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<typeof sparePartsControllerConfirmDelivery>>, TError, { data: ConfirmDeliveryDto }, TContext> => {
    const mutationKey = ['sparePartsControllerConfirmDelivery'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof sparePartsControllerConfirmDelivery>>, { data: ConfirmDeliveryDto }> = (
        props
    ) => {
        const { data } = props ?? {};

        return sparePartsControllerConfirmDelivery(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SparePartsControllerConfirmDeliveryMutationResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerConfirmDelivery>>
>;
export type SparePartsControllerConfirmDeliveryMutationBody = ConfirmDeliveryDto;
export type SparePartsControllerConfirmDeliveryMutationError = void;

/**
 * @summary Confirm delivery of a shipment at project site
 */
export const useSparePartsControllerConfirmDelivery = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerConfirmDelivery>>,
        TError,
        { data: ConfirmDeliveryDto },
        TContext
    >;
}): UseMutationResult<Awaited<ReturnType<typeof sparePartsControllerConfirmDelivery>>, TError, { data: ConfirmDeliveryDto }, TContext> => {
    const mutationOptions = getSparePartsControllerConfirmDeliveryMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Transfer spare parts between projects
 */
export const sparePartsControllerTransferSpareParts = (transferSparePartsDto: TransferSparePartsDto, signal?: AbortSignal) => {
    return platformAxios<TransferSparePartsResponseDto>({
        url: `/api/spare-parts/transfer-spare-parts`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: transferSparePartsDto,
        signal
    });
};

export const getSparePartsControllerTransferSparePartsMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerTransferSpareParts>>,
        TError,
        { data: TransferSparePartsDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sparePartsControllerTransferSpareParts>>,
    TError,
    { data: TransferSparePartsDto },
    TContext
> => {
    const mutationKey = ['sparePartsControllerTransferSpareParts'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sparePartsControllerTransferSpareParts>>,
        { data: TransferSparePartsDto }
    > = (props) => {
        const { data } = props ?? {};

        return sparePartsControllerTransferSpareParts(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SparePartsControllerTransferSparePartsMutationResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerTransferSpareParts>>
>;
export type SparePartsControllerTransferSparePartsMutationBody = TransferSparePartsDto;
export type SparePartsControllerTransferSparePartsMutationError = void;

/**
 * @summary Transfer spare parts between projects
 */
export const useSparePartsControllerTransferSpareParts = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerTransferSpareParts>>,
        TError,
        { data: TransferSparePartsDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sparePartsControllerTransferSpareParts>>,
    TError,
    { data: TransferSparePartsDto },
    TContext
> => {
    const mutationOptions = getSparePartsControllerTransferSparePartsMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Get current stock inventory of spare parts for a project
 */
export const sparePartsControllerGetProjectLocalInventory = (projectCode: string, signal?: AbortSignal) => {
    return platformAxios<InventoryResponseDto>({ url: `/api/spare-parts/project-local-inventory/${projectCode}`, method: 'GET', signal });
};

export const getSparePartsControllerGetProjectLocalInventoryQueryKey = (projectCode?: string) => {
    return [`/api/spare-parts/project-local-inventory/${projectCode}`] as const;
};

export const getSparePartsControllerGetProjectLocalInventoryQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>,
    TError = void
>(
    projectCode: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetProjectLocalInventoryQueryKey(projectCode);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>> = ({ signal }) =>
        sparePartsControllerGetProjectLocalInventory(projectCode, signal);

    return { queryKey, queryFn, enabled: !!projectCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetProjectLocalInventoryQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>
>;
export type SparePartsControllerGetProjectLocalInventoryQueryError = void;

/**
 * @summary Get current stock inventory of spare parts for a project
 */

export function useSparePartsControllerGetProjectLocalInventory<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>,
    TError = void
>(
    projectCode: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetProjectLocalInventory>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetProjectLocalInventoryQueryOptions(projectCode, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get buffer inventory for all entities
 */
export const sparePartsControllerGetAllBufferInventory = (signal?: AbortSignal) => {
    return platformAxios<InventoryResponseDto[]>({ url: `/api/spare-parts/buffer-inventory`, method: 'GET', signal });
};

export const getSparePartsControllerGetAllBufferInventoryQueryKey = () => {
    return [`/api/spare-parts/buffer-inventory`] as const;
};

export const getSparePartsControllerGetAllBufferInventoryQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetAllBufferInventoryQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>> = ({ signal }) =>
        sparePartsControllerGetAllBufferInventory(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetAllBufferInventoryQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>
>;
export type SparePartsControllerGetAllBufferInventoryQueryError = unknown;

/**
 * @summary Get buffer inventory for all entities
 */

export function useSparePartsControllerGetAllBufferInventory<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetAllBufferInventory>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetAllBufferInventoryQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get buffer inventory for a specific entity
 */
export const sparePartsControllerGetBufferInventory = (entityCode: 'SK' | 'US', signal?: AbortSignal) => {
    return platformAxios<InventoryResponseDto>({ url: `/api/spare-parts/buffer-inventory/${entityCode}`, method: 'GET', signal });
};

export const getSparePartsControllerGetBufferInventoryQueryKey = (entityCode?: 'SK' | 'US') => {
    return [`/api/spare-parts/buffer-inventory/${entityCode}`] as const;
};

export const getSparePartsControllerGetBufferInventoryQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>,
    TError = void
>(
    entityCode: 'SK' | 'US',
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetBufferInventoryQueryKey(entityCode);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>> = ({ signal }) =>
        sparePartsControllerGetBufferInventory(entityCode, signal);

    return { queryKey, queryFn, enabled: !!entityCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetBufferInventoryQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>
>;
export type SparePartsControllerGetBufferInventoryQueryError = void;

/**
 * @summary Get buffer inventory for a specific entity
 */

export function useSparePartsControllerGetBufferInventory<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>,
    TError = void
>(
    entityCode: 'SK' | 'US',
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetBufferInventory>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetBufferInventoryQueryOptions(entityCode, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get inventory for the authenticated employee
 */
export const sparePartsControllerGetEmployeeInventory = (signal?: AbortSignal) => {
    return platformAxios<InventoryResponseDto>({ url: `/api/spare-parts/my-inventory`, method: 'GET', signal });
};

export const getSparePartsControllerGetEmployeeInventoryQueryKey = () => {
    return [`/api/spare-parts/my-inventory`] as const;
};

export const getSparePartsControllerGetEmployeeInventoryQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>,
    TError = void
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetEmployeeInventoryQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>> = ({ signal }) =>
        sparePartsControllerGetEmployeeInventory(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetEmployeeInventoryQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>
>;
export type SparePartsControllerGetEmployeeInventoryQueryError = void;

/**
 * @summary Get inventory for the authenticated employee
 */

export function useSparePartsControllerGetEmployeeInventory<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>,
    TError = void
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetEmployeeInventory>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetEmployeeInventoryQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get projects eligible for spare parts management
 */
export const sparePartsControllerGetProjectsList = (signal?: AbortSignal) => {
    return platformAxios<EligibleProjectsResponseDto>({ url: `/api/spare-parts/projects-list`, method: 'GET', signal });
};

export const getSparePartsControllerGetProjectsListQueryKey = () => {
    return [`/api/spare-parts/projects-list`] as const;
};

export const getSparePartsControllerGetProjectsListQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetProjectsListQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>> = ({ signal }) =>
        sparePartsControllerGetProjectsList(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetProjectsListQueryResult = NonNullable<Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>>;
export type SparePartsControllerGetProjectsListQueryError = unknown;

/**
 * @summary Get projects eligible for spare parts management
 */

export function useSparePartsControllerGetProjectsList<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetProjectsList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetProjectsListQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get assets for a facility (all projects with same prefix)
 */
export const sparePartsControllerGetFacilityAssets = (projectCode: string, signal?: AbortSignal) => {
    return platformAxios<FacilityAssetsResponseDto>({ url: `/api/spare-parts/facility-assets/${projectCode}`, method: 'GET', signal });
};

export const getSparePartsControllerGetFacilityAssetsQueryKey = (projectCode?: string) => {
    return [`/api/spare-parts/facility-assets/${projectCode}`] as const;
};

export const getSparePartsControllerGetFacilityAssetsQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>,
    TError = void
>(
    projectCode: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetFacilityAssetsQueryKey(projectCode);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>> = ({ signal }) =>
        sparePartsControllerGetFacilityAssets(projectCode, signal);

    return { queryKey, queryFn, enabled: !!projectCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetFacilityAssetsQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>
>;
export type SparePartsControllerGetFacilityAssetsQueryError = void;

/**
 * @summary Get assets for a facility (all projects with same prefix)
 */

export function useSparePartsControllerGetFacilityAssets<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>,
    TError = void
>(
    projectCode: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetFacilityAssets>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetFacilityAssetsQueryOptions(projectCode, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get parts availability across multiple warehouses
 */
export const sparePartsControllerGetPartsAvailability = (params: SparePartsControllerGetPartsAvailabilityParams, signal?: AbortSignal) => {
    return platformAxios<PartsAvailabilityResponseDto>({ url: `/api/spare-parts/availability`, method: 'GET', params, signal });
};

export const getSparePartsControllerGetPartsAvailabilityQueryKey = (params?: SparePartsControllerGetPartsAvailabilityParams) => {
    return [`/api/spare-parts/availability`, ...(params ? [params] : [])] as const;
};

export const getSparePartsControllerGetPartsAvailabilityQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>,
    TError = void
>(
    params: SparePartsControllerGetPartsAvailabilityParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetPartsAvailabilityQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>> = ({ signal }) =>
        sparePartsControllerGetPartsAvailability(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetPartsAvailabilityQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>
>;
export type SparePartsControllerGetPartsAvailabilityQueryError = void;

/**
 * @summary Get parts availability across multiple warehouses
 */

export function useSparePartsControllerGetPartsAvailability<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>,
    TError = void
>(
    params: SparePartsControllerGetPartsAvailabilityParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetPartsAvailability>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetPartsAvailabilityQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get BOM parts by asset serial number
 */
export const sparePartsControllerGetPartsByAssetSerial = (serialNumber: string, signal?: AbortSignal) => {
    return platformAxios<SearchPartsResponseDto>({ url: `/api/spare-parts/catalog/by-serial/${serialNumber}`, method: 'GET', signal });
};

export const getSparePartsControllerGetPartsByAssetSerialQueryKey = (serialNumber?: string) => {
    return [`/api/spare-parts/catalog/by-serial/${serialNumber}`] as const;
};

export const getSparePartsControllerGetPartsByAssetSerialQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>,
    TError = void
>(
    serialNumber: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetPartsByAssetSerialQueryKey(serialNumber);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>> = ({ signal }) =>
        sparePartsControllerGetPartsByAssetSerial(serialNumber, signal);

    return { queryKey, queryFn, enabled: !!serialNumber, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetPartsByAssetSerialQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>
>;
export type SparePartsControllerGetPartsByAssetSerialQueryError = void;

/**
 * @summary Get BOM parts by asset serial number
 */

export function useSparePartsControllerGetPartsByAssetSerial<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>,
    TError = void
>(
    serialNumber: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetPartsByAssetSerial>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetPartsByAssetSerialQueryOptions(serialNumber, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Search spare parts by term
 */
export const sparePartsControllerSearchParts = (params: SparePartsControllerSearchPartsParams, signal?: AbortSignal) => {
    return platformAxios<SearchPartsResponseDto>({ url: `/api/spare-parts/catalog/search`, method: 'GET', params, signal });
};

export const getSparePartsControllerSearchPartsQueryKey = (params?: SparePartsControllerSearchPartsParams) => {
    return [`/api/spare-parts/catalog/search`, ...(params ? [params] : [])] as const;
};

export const getSparePartsControllerSearchPartsQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerSearchParts>>,
    TError = void
>(
    params: SparePartsControllerSearchPartsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerSearchParts>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerSearchPartsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerSearchParts>>> = ({ signal }) =>
        sparePartsControllerSearchParts(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerSearchParts>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerSearchPartsQueryResult = NonNullable<Awaited<ReturnType<typeof sparePartsControllerSearchParts>>>;
export type SparePartsControllerSearchPartsQueryError = void;

/**
 * @summary Search spare parts by term
 */

export function useSparePartsControllerSearchParts<TData = Awaited<ReturnType<typeof sparePartsControllerSearchParts>>, TError = void>(
    params: SparePartsControllerSearchPartsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerSearchParts>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerSearchPartsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get top wanted spare parts
 */
export const sparePartsControllerGetTopWantedParts = (signal?: AbortSignal) => {
    return platformAxios<SearchPartsResponseDto>({ url: `/api/spare-parts/catalog/top-wanted`, method: 'GET', signal });
};

export const getSparePartsControllerGetTopWantedPartsQueryKey = () => {
    return [`/api/spare-parts/catalog/top-wanted`] as const;
};

export const getSparePartsControllerGetTopWantedPartsQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetTopWantedPartsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>> = ({ signal }) =>
        sparePartsControllerGetTopWantedParts(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetTopWantedPartsQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>
>;
export type SparePartsControllerGetTopWantedPartsQueryError = unknown;

/**
 * @summary Get top wanted spare parts
 */

export function useSparePartsControllerGetTopWantedParts<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>,
    TError = unknown
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetTopWantedParts>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetTopWantedPartsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get eligible spare parts by optional filters
 */
export const sparePartsControllerGetEligibleParts = (params?: SparePartsControllerGetEligiblePartsParams, signal?: AbortSignal) => {
    return platformAxios<SearchPartsResponseDto>({ url: `/api/spare-parts/catalog/eligible`, method: 'GET', params, signal });
};

export const getSparePartsControllerGetEligiblePartsQueryKey = (params?: SparePartsControllerGetEligiblePartsParams) => {
    return [`/api/spare-parts/catalog/eligible`, ...(params ? [params] : [])] as const;
};

export const getSparePartsControllerGetEligiblePartsQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>,
    TError = unknown
>(
    params?: SparePartsControllerGetEligiblePartsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetEligiblePartsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>> = ({ signal }) =>
        sparePartsControllerGetEligibleParts(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetEligiblePartsQueryResult = NonNullable<Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>>;
export type SparePartsControllerGetEligiblePartsQueryError = unknown;

/**
 * @summary Get eligible spare parts by optional filters
 */

export function useSparePartsControllerGetEligibleParts<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>,
    TError = unknown
>(
    params?: SparePartsControllerGetEligiblePartsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetEligibleParts>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetEligiblePartsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get spare part by exact part number (for QR scan)
 */
export const sparePartsControllerGetPartByNumber = (partNumber: string, signal?: AbortSignal) => {
    return platformAxios<SearchPartsResponseDto>({ url: `/api/spare-parts/catalog/${partNumber}`, method: 'GET', signal });
};

export const getSparePartsControllerGetPartByNumberQueryKey = (partNumber?: string) => {
    return [`/api/spare-parts/catalog/${partNumber}`] as const;
};

export const getSparePartsControllerGetPartByNumberQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>,
    TError = void
>(
    partNumber: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetPartByNumberQueryKey(partNumber);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>> = ({ signal }) =>
        sparePartsControllerGetPartByNumber(partNumber, signal);

    return { queryKey, queryFn, enabled: !!partNumber, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetPartByNumberQueryResult = NonNullable<Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>>;
export type SparePartsControllerGetPartByNumberQueryError = void;

/**
 * @summary Get spare part by exact part number (for QR scan)
 */

export function useSparePartsControllerGetPartByNumber<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>,
    TError = void
>(
    partNumber: string,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetPartByNumber>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetPartByNumberQueryOptions(partNumber, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get consumption history for a project
 */
export const sparePartsControllerGetConsumptionHistory = (
    projectCode: string,
    params?: SparePartsControllerGetConsumptionHistoryParams,
    signal?: AbortSignal
) => {
    return platformAxios<ConsumptionHistoryResponseDto>({
        url: `/api/spare-parts/consumption-history/${projectCode}`,
        method: 'GET',
        params,
        signal
    });
};

export const getSparePartsControllerGetConsumptionHistoryQueryKey = (
    projectCode?: string,
    params?: SparePartsControllerGetConsumptionHistoryParams
) => {
    return [`/api/spare-parts/consumption-history/${projectCode}`, ...(params ? [params] : [])] as const;
};

export const getSparePartsControllerGetConsumptionHistoryQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>,
    TError = void
>(
    projectCode: string,
    params?: SparePartsControllerGetConsumptionHistoryParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetConsumptionHistoryQueryKey(projectCode, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>> = ({ signal }) =>
        sparePartsControllerGetConsumptionHistory(projectCode, params, signal);

    return { queryKey, queryFn, enabled: !!projectCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetConsumptionHistoryQueryResult = NonNullable<
    Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>
>;
export type SparePartsControllerGetConsumptionHistoryQueryError = void;

/**
 * @summary Get consumption history for a project
 */

export function useSparePartsControllerGetConsumptionHistory<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>,
    TError = void
>(
    projectCode: string,
    params?: SparePartsControllerGetConsumptionHistoryParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetConsumptionHistory>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetConsumptionHistoryQueryOptions(projectCode, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Submit inventory recount results
 */
export const sparePartsControllerSubmitRecount = (submitRecountDto: SubmitRecountDto, signal?: AbortSignal) => {
    return platformAxios<SubmitRecountResponseDto>({
        url: `/api/spare-parts/submit-recount`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: submitRecountDto,
        signal
    });
};

export const getSparePartsControllerSubmitRecountMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerSubmitRecount>>,
        TError,
        { data: SubmitRecountDto },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<typeof sparePartsControllerSubmitRecount>>, TError, { data: SubmitRecountDto }, TContext> => {
    const mutationKey = ['sparePartsControllerSubmitRecount'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof sparePartsControllerSubmitRecount>>, { data: SubmitRecountDto }> = (
        props
    ) => {
        const { data } = props ?? {};

        return sparePartsControllerSubmitRecount(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SparePartsControllerSubmitRecountMutationResult = NonNullable<Awaited<ReturnType<typeof sparePartsControllerSubmitRecount>>>;
export type SparePartsControllerSubmitRecountMutationBody = SubmitRecountDto;
export type SparePartsControllerSubmitRecountMutationError = void;

/**
 * @summary Submit inventory recount results
 */
export const useSparePartsControllerSubmitRecount = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sparePartsControllerSubmitRecount>>,
        TError,
        { data: SubmitRecountDto },
        TContext
    >;
}): UseMutationResult<Awaited<ReturnType<typeof sparePartsControllerSubmitRecount>>, TError, { data: SubmitRecountDto }, TContext> => {
    const mutationOptions = getSparePartsControllerSubmitRecountMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Get spare parts orders and shipments for a project
 */
export const sparePartsControllerGetProjectOrders = (
    projectCode: string,
    params?: SparePartsControllerGetProjectOrdersParams,
    signal?: AbortSignal
) => {
    return platformAxios<ProjectOrdersResponseDto>({
        url: `/api/spare-parts/project-orders/${projectCode}`,
        method: 'GET',
        params,
        signal
    });
};

export const getSparePartsControllerGetProjectOrdersQueryKey = (
    projectCode?: string,
    params?: SparePartsControllerGetProjectOrdersParams
) => {
    return [`/api/spare-parts/project-orders/${projectCode}`, ...(params ? [params] : [])] as const;
};

export const getSparePartsControllerGetProjectOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>,
    TError = void
>(
    projectCode: string,
    params?: SparePartsControllerGetProjectOrdersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSparePartsControllerGetProjectOrdersQueryKey(projectCode, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>> = ({ signal }) =>
        sparePartsControllerGetProjectOrders(projectCode, params, signal);

    return { queryKey, queryFn, enabled: !!projectCode, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SparePartsControllerGetProjectOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>>;
export type SparePartsControllerGetProjectOrdersQueryError = void;

/**
 * @summary Get spare parts orders and shipments for a project
 */

export function useSparePartsControllerGetProjectOrders<
    TData = Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>,
    TError = void
>(
    projectCode: string,
    params?: SparePartsControllerGetProjectOrdersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof sparePartsControllerGetProjectOrders>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSparePartsControllerGetProjectOrdersQueryOptions(projectCode, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Report a data quality issue with a part
 */
export const feedbackControllerReportPartIssue = (reportPartIssueDto: ReportPartIssueDto, signal?: AbortSignal) => {
    return platformAxios<ReportPartIssueResponseDto>({
        url: `/api/feedback/part-issues`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reportPartIssueDto,
        signal
    });
};

export const getFeedbackControllerReportPartIssueMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportPartIssue>>,
        TError,
        { data: ReportPartIssueDto },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<typeof feedbackControllerReportPartIssue>>, TError, { data: ReportPartIssueDto }, TContext> => {
    const mutationKey = ['feedbackControllerReportPartIssue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof feedbackControllerReportPartIssue>>, { data: ReportPartIssueDto }> = (
        props
    ) => {
        const { data } = props ?? {};

        return feedbackControllerReportPartIssue(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FeedbackControllerReportPartIssueMutationResult = NonNullable<Awaited<ReturnType<typeof feedbackControllerReportPartIssue>>>;
export type FeedbackControllerReportPartIssueMutationBody = ReportPartIssueDto;
export type FeedbackControllerReportPartIssueMutationError = void;

/**
 * @summary Report a data quality issue with a part
 */
export const useFeedbackControllerReportPartIssue = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportPartIssue>>,
        TError,
        { data: ReportPartIssueDto },
        TContext
    >;
}): UseMutationResult<Awaited<ReturnType<typeof feedbackControllerReportPartIssue>>, TError, { data: ReportPartIssueDto }, TContext> => {
    const mutationOptions = getFeedbackControllerReportPartIssueMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Report a data quality issue with project info
 */
export const feedbackControllerReportProjectIssue = (reportProjectIssueDto: ReportProjectIssueDto, signal?: AbortSignal) => {
    return platformAxios<ReportProjectIssueResponseDto>({
        url: `/api/feedback/project-issues`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reportProjectIssueDto,
        signal
    });
};

export const getFeedbackControllerReportProjectIssueMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportProjectIssue>>,
        TError,
        { data: ReportProjectIssueDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof feedbackControllerReportProjectIssue>>,
    TError,
    { data: ReportProjectIssueDto },
    TContext
> => {
    const mutationKey = ['feedbackControllerReportProjectIssue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof feedbackControllerReportProjectIssue>>,
        { data: ReportProjectIssueDto }
    > = (props) => {
        const { data } = props ?? {};

        return feedbackControllerReportProjectIssue(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FeedbackControllerReportProjectIssueMutationResult = NonNullable<
    Awaited<ReturnType<typeof feedbackControllerReportProjectIssue>>
>;
export type FeedbackControllerReportProjectIssueMutationBody = ReportProjectIssueDto;
export type FeedbackControllerReportProjectIssueMutationError = void;

/**
 * @summary Report a data quality issue with project info
 */
export const useFeedbackControllerReportProjectIssue = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportProjectIssue>>,
        TError,
        { data: ReportProjectIssueDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof feedbackControllerReportProjectIssue>>,
    TError,
    { data: ReportProjectIssueDto },
    TContext
> => {
    const mutationOptions = getFeedbackControllerReportProjectIssueMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Report an inventory discrepancy
 */
export const feedbackControllerReportInventoryDiscrepancy = (
    reportInventoryDiscrepancyDto: ReportInventoryDiscrepancyDto,
    signal?: AbortSignal
) => {
    return platformAxios<ReportInventoryDiscrepancyResponseDto>({
        url: `/api/feedback/inventory-discrepancy`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reportInventoryDiscrepancyDto,
        signal
    });
};

export const getFeedbackControllerReportInventoryDiscrepancyMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportInventoryDiscrepancy>>,
        TError,
        { data: ReportInventoryDiscrepancyDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof feedbackControllerReportInventoryDiscrepancy>>,
    TError,
    { data: ReportInventoryDiscrepancyDto },
    TContext
> => {
    const mutationKey = ['feedbackControllerReportInventoryDiscrepancy'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof feedbackControllerReportInventoryDiscrepancy>>,
        { data: ReportInventoryDiscrepancyDto }
    > = (props) => {
        const { data } = props ?? {};

        return feedbackControllerReportInventoryDiscrepancy(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FeedbackControllerReportInventoryDiscrepancyMutationResult = NonNullable<
    Awaited<ReturnType<typeof feedbackControllerReportInventoryDiscrepancy>>
>;
export type FeedbackControllerReportInventoryDiscrepancyMutationBody = ReportInventoryDiscrepancyDto;
export type FeedbackControllerReportInventoryDiscrepancyMutationError = void;

/**
 * @summary Report an inventory discrepancy
 */
export const useFeedbackControllerReportInventoryDiscrepancy = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportInventoryDiscrepancy>>,
        TError,
        { data: ReportInventoryDiscrepancyDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof feedbackControllerReportInventoryDiscrepancy>>,
    TError,
    { data: ReportInventoryDiscrepancyDto },
    TContext
> => {
    const mutationOptions = getFeedbackControllerReportInventoryDiscrepancyMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Report a shipment delivery problem
 */
export const feedbackControllerReportShipmentProblem = (
    feedbackControllerReportShipmentProblemBody: FeedbackControllerReportShipmentProblemBody,
    signal?: AbortSignal
) => {
    const formData = new FormData();
    formData.append(`projectCode`, feedbackControllerReportShipmentProblemBody.projectCode);
    formData.append(`shipmentRef`, feedbackControllerReportShipmentProblemBody.shipmentRef);
    formData.append(`problemType`, feedbackControllerReportShipmentProblemBody.problemType);
    if (feedbackControllerReportShipmentProblemBody.description !== undefined) {
        formData.append(`description`, feedbackControllerReportShipmentProblemBody.description);
    }
    if (feedbackControllerReportShipmentProblemBody.source !== undefined) {
        formData.append(`source`, feedbackControllerReportShipmentProblemBody.source);
    }
    if (feedbackControllerReportShipmentProblemBody.photo !== undefined) {
        formData.append(`photo`, feedbackControllerReportShipmentProblemBody.photo);
    }

    return platformAxios<ReportShipmentProblemResponseDto>({
        url: `/api/feedback/shipment-problems`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        signal
    });
};

export const getFeedbackControllerReportShipmentProblemMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportShipmentProblem>>,
        TError,
        { data: FeedbackControllerReportShipmentProblemBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof feedbackControllerReportShipmentProblem>>,
    TError,
    { data: FeedbackControllerReportShipmentProblemBody },
    TContext
> => {
    const mutationKey = ['feedbackControllerReportShipmentProblem'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof feedbackControllerReportShipmentProblem>>,
        { data: FeedbackControllerReportShipmentProblemBody }
    > = (props) => {
        const { data } = props ?? {};

        return feedbackControllerReportShipmentProblem(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type FeedbackControllerReportShipmentProblemMutationResult = NonNullable<
    Awaited<ReturnType<typeof feedbackControllerReportShipmentProblem>>
>;
export type FeedbackControllerReportShipmentProblemMutationBody = FeedbackControllerReportShipmentProblemBody;
export type FeedbackControllerReportShipmentProblemMutationError = void;

/**
 * @summary Report a shipment delivery problem
 */
export const useFeedbackControllerReportShipmentProblem = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof feedbackControllerReportShipmentProblem>>,
        TError,
        { data: FeedbackControllerReportShipmentProblemBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof feedbackControllerReportShipmentProblem>>,
    TError,
    { data: FeedbackControllerReportShipmentProblemBody },
    TContext
> => {
    const mutationOptions = getFeedbackControllerReportShipmentProblemMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Get available entities (business units)
 */
export const supplyHubControllerGetEntities = (params: SupplyHubControllerGetEntitiesParams, signal?: AbortSignal) => {
    return platformAxios<EntitiesResponseDto>({ url: `/api/supply-hub/entities`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetEntitiesQueryKey = (params?: SupplyHubControllerGetEntitiesParams) => {
    return [`/api/supply-hub/entities`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetEntitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetEntities>>,
    TError = unknown
>(
    params: SupplyHubControllerGetEntitiesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetEntities>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetEntitiesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetEntities>>> = ({ signal }) =>
        supplyHubControllerGetEntities(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetEntities>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof supplyHubControllerGetEntities>>>;
export type SupplyHubControllerGetEntitiesQueryError = unknown;

/**
 * @summary Get available entities (business units)
 */

export function useSupplyHubControllerGetEntities<TData = Awaited<ReturnType<typeof supplyHubControllerGetEntities>>, TError = unknown>(
    params: SupplyHubControllerGetEntitiesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetEntities>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetEntitiesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get active projects for an entity
 */
export const supplyHubControllerGetProjects = (params: SupplyHubControllerGetProjectsParams, signal?: AbortSignal) => {
    return platformAxios<ProjectsResponseDto>({ url: `/api/supply-hub/projects`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetProjectsQueryKey = (params?: SupplyHubControllerGetProjectsParams) => {
    return [`/api/supply-hub/projects`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetProjectsQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetProjects>>,
    TError = unknown
>(
    params: SupplyHubControllerGetProjectsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetProjects>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetProjectsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetProjects>>> = ({ signal }) =>
        supplyHubControllerGetProjects(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetProjects>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof supplyHubControllerGetProjects>>>;
export type SupplyHubControllerGetProjectsQueryError = unknown;

/**
 * @summary Get active projects for an entity
 */

export function useSupplyHubControllerGetProjects<TData = Awaited<ReturnType<typeof supplyHubControllerGetProjects>>, TError = unknown>(
    params: SupplyHubControllerGetProjectsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetProjects>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetProjectsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get costing dimension values (1-5)
 */
export const supplyHubControllerGetCostingDimensions = (params: SupplyHubControllerGetCostingDimensionsParams, signal?: AbortSignal) => {
    return platformAxios<CostingDimensionsResponseDto>({ url: `/api/supply-hub/costing-dimensions`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetCostingDimensionsQueryKey = (params?: SupplyHubControllerGetCostingDimensionsParams) => {
    return [`/api/supply-hub/costing-dimensions`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetCostingDimensionsQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>,
    TError = unknown
>(
    params: SupplyHubControllerGetCostingDimensionsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetCostingDimensionsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>> = ({ signal }) =>
        supplyHubControllerGetCostingDimensions(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetCostingDimensionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>
>;
export type SupplyHubControllerGetCostingDimensionsQueryError = unknown;

/**
 * @summary Get costing dimension values (1-5)
 */

export function useSupplyHubControllerGetCostingDimensions<
    TData = Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>,
    TError = unknown
>(
    params: SupplyHubControllerGetCostingDimensionsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetCostingDimensions>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetCostingDimensionsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get available budgets for an entity
 */
export const supplyHubControllerGetBudgets = (params: SupplyHubControllerGetBudgetsParams, signal?: AbortSignal) => {
    return platformAxios<BudgetsResponseDto>({ url: `/api/supply-hub/budgets`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetBudgetsQueryKey = (params?: SupplyHubControllerGetBudgetsParams) => {
    return [`/api/supply-hub/budgets`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetBudgetsQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>,
    TError = unknown
>(
    params: SupplyHubControllerGetBudgetsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetBudgetsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>> = ({ signal }) =>
        supplyHubControllerGetBudgets(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetBudgetsQueryResult = NonNullable<Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>>;
export type SupplyHubControllerGetBudgetsQueryError = unknown;

/**
 * @summary Get available budgets for an entity
 */

export function useSupplyHubControllerGetBudgets<TData = Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>, TError = unknown>(
    params: SupplyHubControllerGetBudgetsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetBudgets>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetBudgetsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get item categories (property names) for an entity
 */
export const supplyHubControllerGetCategories = (params: SupplyHubControllerGetCategoriesParams, signal?: AbortSignal) => {
    return platformAxios<CategoriesResponseDto>({ url: `/api/supply-hub/categories`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetCategoriesQueryKey = (params?: SupplyHubControllerGetCategoriesParams) => {
    return [`/api/supply-hub/categories`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetCategoriesQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetCategories>>,
    TError = unknown
>(
    params: SupplyHubControllerGetCategoriesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetCategories>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetCategoriesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetCategories>>> = ({ signal }) =>
        supplyHubControllerGetCategories(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetCategories>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof supplyHubControllerGetCategories>>>;
export type SupplyHubControllerGetCategoriesQueryError = unknown;

/**
 * @summary Get item categories (property names) for an entity
 */

export function useSupplyHubControllerGetCategories<TData = Awaited<ReturnType<typeof supplyHubControllerGetCategories>>, TError = unknown>(
    params: SupplyHubControllerGetCategoriesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetCategories>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetCategoriesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get catalog items with stock levels and pricing
 */
export const supplyHubControllerGetCatalog = (params: SupplyHubControllerGetCatalogParams, signal?: AbortSignal) => {
    return platformAxios<CatalogResponseDto>({ url: `/api/supply-hub/catalog`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetCatalogQueryKey = (params?: SupplyHubControllerGetCatalogParams) => {
    return [`/api/supply-hub/catalog`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetCatalogQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>,
    TError = unknown
>(
    params: SupplyHubControllerGetCatalogParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetCatalogQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>> = ({ signal }) =>
        supplyHubControllerGetCatalog(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>>;
export type SupplyHubControllerGetCatalogQueryError = unknown;

/**
 * @summary Get catalog items with stock levels and pricing
 */

export function useSupplyHubControllerGetCatalog<TData = Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>, TError = unknown>(
    params: SupplyHubControllerGetCatalogParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetCatalog>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetCatalogQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary List purchase requests for an entity
 */
export const supplyHubControllerGetPurchaseRequests = (params: SupplyHubControllerGetPurchaseRequestsParams, signal?: AbortSignal) => {
    return platformAxios<PurchaseRequestsResponseDto>({ url: `/api/supply-hub/purchase-requests`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetPurchaseRequestsQueryKey = (params?: SupplyHubControllerGetPurchaseRequestsParams) => {
    return [`/api/supply-hub/purchase-requests`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetPurchaseRequestsQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>,
    TError = unknown
>(
    params: SupplyHubControllerGetPurchaseRequestsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetPurchaseRequestsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>> = ({ signal }) =>
        supplyHubControllerGetPurchaseRequests(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetPurchaseRequestsQueryResult = NonNullable<
    Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>
>;
export type SupplyHubControllerGetPurchaseRequestsQueryError = unknown;

/**
 * @summary List purchase requests for an entity
 */

export function useSupplyHubControllerGetPurchaseRequests<
    TData = Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>,
    TError = unknown
>(
    params: SupplyHubControllerGetPurchaseRequestsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseRequests>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetPurchaseRequestsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a purchase request
 */
export const supplyHubControllerCreatePurchaseRequest = (
    createPurchaseRequestInputDto: CreatePurchaseRequestInputDto,
    signal?: AbortSignal
) => {
    return platformAxios<CreatePurchaseRequestResponseDto>({
        url: `/api/supply-hub/purchase-requests`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createPurchaseRequestInputDto,
        signal
    });
};

export const getSupplyHubControllerCreatePurchaseRequestMutationOptions = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof supplyHubControllerCreatePurchaseRequest>>,
        TError,
        { data: CreatePurchaseRequestInputDto },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof supplyHubControllerCreatePurchaseRequest>>,
    TError,
    { data: CreatePurchaseRequestInputDto },
    TContext
> => {
    const mutationKey = ['supplyHubControllerCreatePurchaseRequest'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof supplyHubControllerCreatePurchaseRequest>>,
        { data: CreatePurchaseRequestInputDto }
    > = (props) => {
        const { data } = props ?? {};

        return supplyHubControllerCreatePurchaseRequest(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SupplyHubControllerCreatePurchaseRequestMutationResult = NonNullable<
    Awaited<ReturnType<typeof supplyHubControllerCreatePurchaseRequest>>
>;
export type SupplyHubControllerCreatePurchaseRequestMutationBody = CreatePurchaseRequestInputDto;
export type SupplyHubControllerCreatePurchaseRequestMutationError = void;

/**
 * @summary Create a purchase request
 */
export const useSupplyHubControllerCreatePurchaseRequest = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof supplyHubControllerCreatePurchaseRequest>>,
        TError,
        { data: CreatePurchaseRequestInputDto },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof supplyHubControllerCreatePurchaseRequest>>,
    TError,
    { data: CreatePurchaseRequestInputDto },
    TContext
> => {
    const mutationOptions = getSupplyHubControllerCreatePurchaseRequestMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary List purchase orders for an entity
 */
export const supplyHubControllerGetPurchaseOrders = (params: SupplyHubControllerGetPurchaseOrdersParams, signal?: AbortSignal) => {
    return platformAxios<PurchaseOrdersResponseDto>({ url: `/api/supply-hub/purchase-orders`, method: 'GET', params, signal });
};

export const getSupplyHubControllerGetPurchaseOrdersQueryKey = (params?: SupplyHubControllerGetPurchaseOrdersParams) => {
    return [`/api/supply-hub/purchase-orders`, ...(params ? [params] : [])] as const;
};

export const getSupplyHubControllerGetPurchaseOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>,
    TError = unknown
>(
    params: SupplyHubControllerGetPurchaseOrdersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>, TError, TData> }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getSupplyHubControllerGetPurchaseOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>> = ({ signal }) =>
        supplyHubControllerGetPurchaseOrders(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type SupplyHubControllerGetPurchaseOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>>;
export type SupplyHubControllerGetPurchaseOrdersQueryError = unknown;

/**
 * @summary List purchase orders for an entity
 */

export function useSupplyHubControllerGetPurchaseOrders<
    TData = Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>,
    TError = unknown
>(
    params: SupplyHubControllerGetPurchaseOrdersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof supplyHubControllerGetPurchaseOrders>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getSupplyHubControllerGetPurchaseOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
